export const BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');
export const VITE_ASSETS_URL = import.meta.env.VITE_ASSETS_URL;
export const MOBILE_APP_URL = import.meta.env.VITE_MOBILE_APP_URL;
export const APP_STORE_URL = import.meta.env.VITE_APP_STORE_URL;
export const PLAY_STORE_URL = import.meta.env.VITE_PLAY_STORE_URL;
export const WEB_URL = import.meta.env.VITE_WEB_URL || window.location.origin;

// Regular expressions for validation
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;

// Product names (sync with backend)
export const COMMANDER_AI = 'Commander AI';
export const COMMANDER_EXPO = 'Commander Expo';
